import { useEffect, useState } from 'react';

/**
 * Geeft na mount de actuele, tijdgebonden waarde terug.
 *
 * De eerste render (ook die van het prerenderen) gebruikt `baseValue`, zodat
 * server en client bij hydration hetzelfde HTML opleveren. Daarna wordt de
 * waarde bijgewerkt en blijft hij meelopen zolang de pagina open staat.
 */
export function useLiveCount(baseValue: number, compute: () => number): number {
  const [value, setValue] = useState(baseValue);

  useEffect(() => {
    const update = () => setValue((current) => Math.max(current, compute()));
    update();
    const interval = window.setInterval(update, 60_000);
    return () => window.clearInterval(interval);
  }, [compute]);

  return value;
}
